<!-- BR#205 Mbeng 28/07/2026 withdrawal success popup -->
<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-container">
      <!-- <h3 class="modal-title">
        {{ title }}
      </h3> -->

      <p class="modal-message">
        {{ message }}
      </p>

      <div class="modal-footer">
        <button class="btn-ok" @click="close">
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuccessModal",

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Success"
    },
    message: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: "OK"
    }
  },

  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-container {
  width: 420px;
  max-width: 90%;
  background: #fff;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 8px 30px rgba(0,0,0,.25);
}

.modal-title {
  margin: 0 0 15px;
  font-size: 22px;
  font-weight: 600;
}

.modal-message {
  font-size: 15px;
  line-height: 1.6;
  color: #555;
}

.modal-footer {
  margin-top: 25px;
  text-align: right;
}

.btn-ok {
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 24px;
  cursor: pointer;
  font-size: 14px;
}

.btn-ok:hover {
  background: #1d4ed8;
}
</style>